import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputComponent } from './fc-text-input.component';


@NgModule({
  entryComponents: [
    FcSearchInputComponent
  ],
  declarations: [
    FcSearchInputComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    MatProgressBarModule
  ],
  exports: [
    FcSearchInputComponent
  ]
})
export class FcTextInputModule {}
